let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gpbWI")).then(() => parcelRequire('8K3w4'));